var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('rest-list-column',{attrs:{"prop":_vm.prop,"title":_vm.title,"route":_vm.route,"width":_vm.width,"min-width":_vm.minWidth,"formatter":_vm.formatter,"filter-date-range":_vm.isRange,"filter-date":!_vm.isRange,"date-picker-props":_vm.datePickerProps,"sortable":_vm.sortable,"fixed":_vm.fixed,"filterable":_vm.filterable}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70062967","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/rest/RestListColumnDate.vue
// module id = null
// module chunks = 